import type { RenderLine } from './util'
import { position, validDate } from './util'

// Same endpoint geometry as the legacy link lines: row * 100 + 50.
export default function LinkLines({ lines, start, end }: { lines: RenderLine[]; start: string; end: string }) {
  const points = new Map<string, { x: number; y: number }>()
  const paymentPoints = new Map<string, { x: number; y: number }>()
  lines.forEach((l, i) => l.nodes.forEach(n => {
    if (!validDate(n.date) || n.date < start || n.date > end) return
    const point = { x: position(n.date, start, end), y: i * 100 + 50 }
    points.set(`${l.nodeType === 'default' ? 'zbControlNode' : 'zbMilestone'}:${n.id}`, point)
    points.set(`node:${l.lineID}:${n.id}`, point)
    if (l.nodeType === 'payment' && n.external?.pmCode) paymentPoints.set(n.external.pmCode, point)
  }))
  const paths: { key: string; from: { x: number; y: number }; to: { x: number; y: number } }[] = []
  lines.forEach(l => l.nodes.forEach(n => {
    if (l.nodeType === 'default') {
      const from = points.get(`zbControlNode:${n.id}`)
      if (!from) return
      n.links.forEach(link => { const to = points.get(`${link.targetType}:${link.targetId}`); if (to) paths.push({ key: `${n.id}:${link.targetType}:${link.targetId}`, from, to }) })
    }
    if (l.nodeType === 'expense') {
      const from = points.get(`node:${l.lineID}:${n.id}`)
      if (!from) return
      n.external?.links?.forEach(link => { const to = paymentPoints.get(link.toCode); if (to) paths.push({ key: `expense:${n.id}:${link.toCode}`, from, to }) })
    }
  }))
  return <svg className="absolute inset-0 w-full h-full pointer-events-none z-20" aria-label="节点关联线">
    <defs><marker id="zb-link-arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse"><path d="M 0 0 L 10 5 L 0 10 z" fill="#888" /></marker></defs>
    {paths.map(p => <line key={p.key} x1={`${p.from.x}%`} y1={p.from.y} x2={`${p.to.x}%`} y2={p.to.y} stroke="#888" strokeDasharray="5 4" markerEnd="url(#zb-link-arrow)" />)}
  </svg>
}
